import { SecurityConfirm } from 'components'
import NovaCaptacao from './NovaCaptacao'
import DetalhesCaptacao from './DetalhesCaptacao'
import ResumoCaptacao from './ResumoCaptacao'
import Comission from './Comission'
import NovoEmpreendimento from './NovoEmpreendimento'
import DetalhesEmpreendimento from './DetalhesEmpreendimento'
import DetalhesNewCaption from './DetalhesNovaCaptacao/indexCopy'

export const baseCaptacao: any = [
  [<NovaCaptacao />],
  [<SecurityConfirm hasButtonBack />],
]

export const novaCaptacao: any = [
  [<NovaCaptacao />],
  [
    <ResumoCaptacao
      path={`Gestão de produtos >  Investimentos  > Nova captação  > Layout`}
    />,
  ],
  [<DetalhesNewCaption hasButtonBack />],
  [<Comission />],
  [<SecurityConfirm />],
]

export const newEmpreendimento: any = [
  [<NovoEmpreendimento />],
  [
    <ResumoCaptacao
      path={`Gestão de produtos >  Investimentos  > Novo Empreendimento  > Layout`}
    />,
  ],
  [<SecurityConfirm hasButtonBack />],
]

export const captacaoEscolhida: any = [[<DetalhesCaptacao />]]

export const empreendimentoEscolhido: any = [[<DetalhesEmpreendimento />]]
